<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/account"></ion-back-button>
    </ion-buttons>
    <ion-title>My Posts</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)" color="primary">
    <ion-refresher-content pullingText="Pull to refresh" refreshingSpinner="circular" refreshingText="Refreshing...">
    </ion-refresher-content>
  </ion-refresher>
  <div class="ion-padding ion-text-center" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div *ngIf="!isLoading">
    <div>
      <div class="ion-padding ion-text-center" *ngIf="posts.length ===0">
        <ion-text color="darkmimbo">You haven't uploaded any posts.</ion-text>
      </div>
      <div *ngIf="posts.length >0">
        <app-post-card *ngFor="let post of posts" [post]="post" [userId]="userId" [posts]="posts"></app-post-card>
      </div>
      <ion-fab slot="fixed" horizontal="end" vertical="bottom">
        <ion-fab-button>
          <ion-icon name="add"></ion-icon>
        </ion-fab-button>
        <ion-fab-list side="top">
          <ion-fab-button color="primary" (click)="onPickImageFromCamera('Gallery')">
            <ion-icon name="image-outline" style="font-size: 24px"></ion-icon>
          </ion-fab-button>
          <ion-fab-button color="primary" (click)="onPickImageFromCamera('Camera')">
            <ion-icon name="camera-outline" style="font-size: 24px"></ion-icon>
          </ion-fab-button>
        </ion-fab-list>
      </ion-fab>
    </div>
  </div>
  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)" *ngIf="!isLoading && HasMoreData">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>